import { style } from "typestyle";
import { colors } from "styles/styles";

export const pagination = style({
  listStyle: "none",
  userSelect: "none",
  margin: "2rem 0 2rem",
  fontWeight: 300,
  textAlign: "center",
  padding: 0,

  $nest: {
    ".disabled": {
      opacity: 0.25,
      $nest: {
        a: { cursor: "initial" }
      }
    },
    li: {
      display: "inline-block",
      textAlign: "center",
      color: colors.hooplaTextColor,

      $nest: {
        "&.active a": {
          fontWeight: "normal",
          borderBottom: `2px solid ${colors.hooplaBlue}`
        },
        a: {
          borderBottom: `2px solid transparent`,
          borderRadius: 2,
          padding: "4px 8px",
          margin: "0 4px",
          cursor: "pointer"
        },

        "a:focus": {
          outline: "none"
        }
      }
    }
  }
});

export const paginationNext = style({
  transform: "scaleY(2.125)",
  marginLeft: 20
});

export const paginationPrev = style({
  transform: "scaleY(2.125)",
  marginRight: 20
});
